import React from 'react';
import styled from '@emotion/styled';
import List from './List';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  margin-top: ${props => props.hasBackground ? '40px' : null};
  padding-bottom: ${props => props.hasBackground ? '40px' : null};
  background: ${props => props.hasBackground ? props.theme.colors.primary.lighter : null};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;

  @media (min-width: ${props => props.theme.breakpoints.s}) and (max-width: ${props => props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 30px 0;
  text-align: center;
  color: ${props => props.textHighlighted ? props.theme.colors.primary.base : props.theme.colors.black.base};
`;
const SubTitle = styled.h3`
  font-size: 26px;
  margin: 30px 0;
  text-align: center;
  color: ${props => props.theme.colors.black.base};
`;
const SectionDescription = styled.p`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  font-family: ${props => props.theme.fontFamily.body};
  color: ${props => props.theme.colors.black.light};
  max-width: 600px;
  margin-bottom: 30px;
  line-height: 28px;
`;
const SubDescription = styled.p`
  font-size: 13px;
  text-align: center;
  font-family: ${props => props.theme.fontFamily.body};
  color: ${props => props.theme.colors.black.light};
  max-width: 450px;
  margin-bottom: 40px;
  line-height: 28px;
`;
const ListContainer = styled.div`
  display: flex;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
  }
`;

const MultiColumnList = props => {
  const { content, titleHighlighted, listTitleHighlighted, listItemTextBold, hasBackground } = props;
  const { title, subTitle, description, subDescription, items } = content ? content : {}
  return (
    <Section hasBackground={hasBackground}>
      <ContentWrapper>
        {title ? (
          <SectionTitle textHighlighted={titleHighlighted}>{title}</SectionTitle>
        ) : null}
        {description ? (
          <SectionDescription>{description}</SectionDescription>
        ) : null}
        {subTitle ? (
          <SubTitle>{subTitle}</SubTitle>
        ) : null}
        {subDescription ? (
          <SubDescription>{subDescription}</SubDescription>
        ) : null}
        <ListContainer>
          {items && items.map((item, idx) => (
            <List key={idx}
              title={item.title}
              titleHighlighted={listTitleHighlighted}
              listItemTextBold={listItemTextBold}
              listStyle={props.listStyle}
              items={item.list} />
          ))}
        </ListContainer>
      </ContentWrapper>
    </Section>
  );
};

export default MultiColumnList;
